// eslint-disable-next-line import/no-anonymous-default-export
export default {
  APP_ENV: process.env.REACT_APP_APP_ENV ? String(process.env.REACT_APP_APP_ENV) : 'production',
  PERSIST_STORE_ENABLED: Number(process.env.REACT_APP_PERSIST_STORE_ENABLED) === 1,
  PUBLIC_URL: process.env.PUBLIC_URL ? String(process.env.PUBLIC_URL) : '',
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL ? String(process.env.REACT_APP_WEBSITE_URL) : '',
  GTM_ID: process.env.REACT_APP_GTM_ID ? String(process.env.REACT_APP_GTM_ID) : '',
}
